// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_94B","cls2":"SplitVerdictPreviewList-cls2_Y9T SplitVerdictPreviewList-cls1_94B"};